import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {TargetGroupsListRoutingModule} from './target-groups-list-routing.module';

import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {TargetGroupsListRepository} from './repositories/target-groups-list.repository';
import {TargetGroupsListService} from './services/target-groups-list.service';
import {TargetGroupsListComponent} from './target-groups-list.component';

@NgModule({
  imports: [
    CommonModule,
    TargetGroupsListRoutingModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    SearchBarModule,
  ],
  declarations: [
    TargetGroupsListComponent,
  ],
  providers: [
    TargetGroupsListService,
    TargetGroupsListRepository,
  ],
})

export class TargetGroupsListModule {}


// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-list/target-groups-list.module.ts